/* Freshbliss - right-size Shopify CDN images for the slot they render in - 30 Oct 2026
   Only touches lazy images that have not started loading and carry no srcset
   and no width parameter, so nothing is ever downloaded twice. */
(function () {
  if (window.__fbImgSize) return;
  window.__fbImgSize = true;

  function sizeImages() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var imgs = document.getElementsByTagName('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.loading !== 'lazy' || img.complete) continue;
      if (img.srcset) continue;
      var src = img.getAttribute('src');
      if (!src) continue;
      if (src.indexOf('/cdn/shop/') === -1 && src.indexOf('cdn.shopify.com') === -1) continue;
      if (src.indexOf('width=') > -1) continue;

      var slot = img.clientWidth || (img.parentElement ? img.parentElement.clientWidth : 0) || 400;
      var target = Math.ceil((slot * dpr) / 100) * 100;
      if (target < 200) target = 200;
      if (target > 1200) target = 1200;

      img.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + target);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sizeImages);
  else sizeImages();
})();
